export const registerServiceWorker = async () => {
    if (!navigator.serviceWorker.controller) {
        try {
            await navigator.serviceWorker.register("/sw.js");
        } catch (error) {
            console.error("Service Worker registration failed:", error);
        }
    }
};
